import { collapseLeadingTimeframes, hasLeadingTimeframe } from 'utils/pql';

export const DEFAULT_PQL = 'last 2 hours';

type SuggestResult = { compiled?: { t1?: number | null; t2?: number | null } } | undefined;

// Decides the query actually submitted for a PQL input. Collapses poisoned repeats, then
// prepends DEFAULT_PQL only when the query verifiably lacks a timeframe:
// no leading timeframe token AND suggest confirms none compiled. A failed
// suggest call must never modify the query — prepending on failure is what
// let corrupted queries compound.
export const resolvePqlQuery = async (
  value: string,
  fetchSuggest: (query: string) => Promise<SuggestResult>,
): Promise<string> => {
  const query = collapseLeadingTimeframes(value);

  if (!query) {
    // whitespace-only input still runs the default search instead of a silent no-op
    return value ? DEFAULT_PQL : query;
  }

  if (hasLeadingTimeframe(query)) {
    return query;
  }

  try {
    const result = await fetchSuggest(query);
    const hasTimeframe = result?.compiled?.t1 != null && result?.compiled?.t2 != null;
    return hasTimeframe ? query : `${DEFAULT_PQL} ${query}`;
  } catch {
    return query;
  }
};
